export enum UnitDatacodeEnum {
  KiloByte = 'KB',
  MegaByte = 'MB',
  GigaByte = 'GB',
  TeraByte = 'TB',
}
